import * as XLSX from "xlsx";
const ExportExcel = ({ fileName, formattedData, headers }) => {
  const worksheet = XLSX.utils.json_to_sheet(formattedData, {
    header: headers,
  });

  // Auto-adjust column widths based on content length
  const wscols = headers.map((header) => {
    const maxLength = formattedData.reduce((max, row) => {
      return row[header] ? Math.max(max, row[header].toString().length) : max;
    }, header.length);
    return { wch: maxLength + 5 }; // Adding padding
  });

  worksheet["!cols"] = wscols;

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, fileName);
  XLSX.writeFile(workbook, `${fileName}.xlsx`);
};

export default ExportExcel;
